import swal from "sweetalert";
import { useState } from "react";
import useUser from "../../../../core/hooks/use-user";
import useModal from "../../../../core/hooks/use-modal";
import { toast } from "../../../../core/helpers/message-helper";
import Datatable from "../../../../core/ui/components/Datatable";
import { sweetAl } from "../../../../core/helpers/message-helper";
import { API_URL } from "../../../../core/config/env";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";
import FormSubArea from "../components/form-sub-areas";
import { activarSubArea, inactivarSubArea, verSubArea } from "../../services/subareas-service";

const SubAreas = () => {
    const { getAccessToken, userCan } = useUser();
    const token = getAccessToken();
    const [dtInstance, onDtInstance] = useState({});

    const modalSubArea = useModal({
        title: "Crear sub area",
        data: { subArea: {} },
    });

    const getDtInstance = (dt) => onDtInstance(dt);

    const onSave = () => {
        dtInstance.ajax.reload();
    };

    let tableButtons = [];

    if (userCan("subAreasCrear")) {
        tableButtons.push({
            titleAttr: "Crear sub area",
            text: '<i class="fas fa-plus"></i>',
            action: function () {
                modalSubArea.open({
                    title: "Crear sub area",
                    data: { subArea: {} },
                });
            },
            className: "btn btn-sm btn-secondary",
        });
    }

    if (userCan("subAreasEditar")) {
        tableButtons.push({
            titleAttr: "Editar sub area",
            text: '<i class="fas fa-pen"></i>',
            action: async function (e, dt) {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const resp = await verSubArea(data.id);
                const subArea = {
                    ...resp.data,
                    sedes: resp.data.sedes.map((sede) => {
                        return {
                            label: sede.nombre.replace(/[^a-zA-Z ]/g, ""),
                            value: sede.id,
                        };
                    }),
                };

                modalSubArea.set({
                    show: true,
                    title: "Editar subArea",
                    data: { subArea },
                });
            },
            className: "btn btn-sm btn-grey",
        });
    }

    if (userCan("subAreasInactivar")) {
        tableButtons.push({
            titleAttr: "Inactivar sub area",
            text: '<i class="fas fa-trash"></i>',
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const value = await swal({
                    title: "Confirmación",
                    text: `¿Seguro que desea inactivar esta sub area?`,
                    icon: "info",
                    buttons: {
                        cancelar: {
                            text: "Cancelar",
                            className: "btn-danger",
                        },
                        eliminar: {
                            text: "Aceptar",
                            className: "btn-success",
                        },
                    },
                });

                switch (value) {
                    case "cancelar":
                        sweetAl.warning("No se ha inactivado la sub area");
                        break;
                    case "eliminar": {
                        const resp = await inactivarSubArea(data.id);
                        if (!resp.status) {
                            return sweetAl.error(
                                "Ha ocurrido un error al inactivar la sub area"
                            );
                        }

                        sweetAl.success(
                            "La sub area fue inactivada correctamente"
                        );
                        dt.ajax.reload();
                        break;
                    }
                }
            },
            className: "btn btn-sm btn-danger",
        });
    }

    if (userCan("subAreasActivar")) {
        tableButtons.push({
            titleAttr: "Activar la sub area",
            text: '<i class="fas fa-check"></i>',
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const value = await swal({
                    title: "Confirmación",
                    text: `¿Seguro que desea activar esta sub area?`,
                    icon: "info",
                    buttons: {
                        cancelar: {
                            text: "Cancelar",
                            className: "btn-danger",
                        },
                        activar: {
                            text: "Aceptar",
                            className: "btn-success",
                        },
                    },
                });

                switch (value) {
                    case "cancelar":
                        sweetAl.warning("No se ha activado la sub area");
                        break;
                    case "activar": {
                        const resp = await activarSubArea(data);
                        if (!resp.status) {
                            return sweetAl.error(
                                "Ha ocurrido un error al activar la sub area"
                            );
                        }

                        sweetAl.success("La sub area fue activada correctamente");
                        dt.ajax.reload();
                        break;
                    }
                }
            },
            className: "btn btn-sm btn-primary",
        });
    }

    tableButtons = [
        ...tableButtons,
        {
            titleAttr: "Exportar a Excel",
            text: '<i class="fas fa-file-excel"></i>',
            extend: "excelHtml5",
            className: "btn btn-sm btn-success",
            exportOptions: {
                modifier: {
                    order: "current",
                    page: "all",
                },
            },
            filename: "sub-areas",
        },
        {
            titleAttr: "Imprimir",
            text: '<i class="fa fa-lg fa-print"></i>',
            extend: "print",
            className: "btn btn-sm btn-warning",
        },
    ];

    const dtOptions = {
        searchable: true,
        serverSide: false,
        dom: "Bfrtip",
        id: "tablaCargos",
        select: {
            style: "single",
        },
        buttons: tableButtons,
        ajax: {
            url: `${API_URL}/subareas`,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", `Bearer ${token}`);
            },
            type: "get",
            dataType: "json",
            error: function () {
                toast.error(
                    "Ha ocurrido un error al obtener el listado de las sub areas"
                );
            },
        },
        columns: [
            { data: "id" },
            { data: "nombre" },
            { data: "descripcion" },
            { data: "nombre_area" },
            { data: "status" },
        ],
        columnDefs: [
            {
                targets: 4,
                createdCell: function (td, cellData) {
                    td.textContent = cellData == 1 ? "Activo" : "Inactivo";
                    td.classList.add(
                        cellData == 1 ? "text-success" : "text-warning"
                    );
                    td.classList.add("text-bold");
                },
            },
        ],
    };

    return (
        <ContentWrapper>
            <div className="content-heading">
                <div>
                    ADMINISTRAR / Sub-Áreas
                </div>
            </div>
            <Datatable options={dtOptions} dtInstance={getDtInstance}>
                <table className="w-100 table table-hover" id="tablaCargos">
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Nombre Sub Area</th>
                            <th>Descripcion</th>
                            <th>Nombre Area</th>
                            <th>Estado</th>
                        </tr>
                    </thead>
                </table>
            </Datatable>
            <FormSubArea modalState={modalSubArea} onSave={onSave} />
        </ContentWrapper>
    );
};

export default SubAreas;
